export default "<a href=\"javascript:;\" class=\"primary-black\" [class.disabled]=\"isDisabled=='true'\" (click)=\"onBtnClick()\" translate>{{btnLabel}}</a>";